import { closeModal, openContextModal } from "@mantine/modals";
import {
	type UpgradeTriggerSource,
	captureUpgradePlanModalOpened,
} from "@src/utils/analytics";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { PlanModalContent } from "./plan-modal-content";

let modalId: string | null = null;

export type OpenPlanModalOptions = {
	source?: UpgradeTriggerSource;
	dismissible?: boolean;
};

export function openPlanModal(options: OpenPlanModalOptions = {}) {
	const { source, dismissible = true } = options;

	if (modalId) {
		return;
	}

	if (source) {
		captureUpgradePlanModalOpened(source);
	}

	modalId = openContextModal({
		modal: "buttonsModal",
		centered: true,
		withCloseButton: false,
		zIndex: 3000,
		size: "min(1000px, 95vw)",
		padding: 0,
		closeOnEscape: dismissible,
		closeOnClickOutside: dismissible,
		classNames: {
			content:
				"relative max-h-[90vh] bg-surface-default shadow-2xl border border-border-subtle rounded-2xl",
			body: "overflow-y-auto max-h-[90vh]",
		},
		onClose: () => {
			modalId = null;
		},
		innerProps: {
			children: (
				<Suspense fallback={null}>
					<ErrorBoundary
						fallbackRender={() => <div>Error loading plan modal</div>}
					>
						<PlanModalContent
							onClose={closePlanModal}
							dismissible={dismissible}
						/>
					</ErrorBoundary>
				</Suspense>
			),
		},
	});
}

export function closePlanModal() {
	if (modalId) {
		closeModal(modalId);
	}
}
